import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({})
export default class ForbiddenView extends Mixins<MixinInterface>() {}
